import Vue from 'vue';
import VueRouter from 'vue-router';
import YanProgress from 'yan-progress';
import App from './App';
import store from './store';
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';

import EventCategory from './components/pages/reservations/EventCategory';
import Conference from './components/pages/conferance/ConferenceCategory';
import Participation from './components/pages/participation/Participation';
import Accommodation from './components/pages/accommodation/Accommodation';
import Confirmation from './components/pages/confirmation/Confirmation';
import MealPreference from './components/pages/meal/MealPreference';
import Activities from './components/pages/activities/Activities';
import Checkout from './components/pages/checkout/Checkout';
import NewEvent from './components/pages/new/NewEvent';
import Result from './components/pages/result/Result';
import NewCheckout from './components/pages/newCheckout/NewCheckout';
import NewConfirmation from './components/pages/newConfirmation/NewConfirmation';
import NewResult from './components/pages/newResult/NewResult';

Vue.use(VueRouter);
Vue.use(YanProgress);

const datepickerOptions = {
    colors: {
        selected: '#ff0000',
        inRange: 'rgba(255, 0, 0, 0.6)',
        selectedText: '#fff',
        text: '#565a5c',
        inRangeBorder: 'rgba(255, 0, 0, 0.6)',
        disabled: '#fff',
        hoveredInRange: 'rgba(255, 0, 0, 0.6)'
    }
}

Vue.use(AirbnbStyleDatepicker, datepickerOptions);

let handleOutsideClick
Vue.directive('closable', {
  bind (el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName]
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },

  unbind () {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', component: EventCategory },
        { path: '/event/:slug+', name: 'event', component: Conference },
        { path: '/conference/:slug+', name: 'conference', component: Participation },
        { path: '/accommodation/:id?', name: 'accommodation', component: Accommodation },
        { path: '/meal', component: MealPreference },
        { path: '/activities', component: Activities },
        { path: '/confirmation', component: Confirmation },        
        { path: '/checkout', component: Checkout },
        { path: '/result', component: Result },        
        { path: '/new-event', component: NewEvent },
        { path: '/new-event-confirmation', component: NewConfirmation },
        { path: '/new-event-checkout', component: NewCheckout },        
        { path: '/event-result', component: NewResult },
    ]
});

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');